<template>
  <el-dialog
            :visible.sync="visible"
            v-loading="loading"
            width="715px"
            height="100%"
            :close-on-click-modal=false
            :close-on-press-escape=false
            :before-close="onCloseDialog">
    <div v-if="users">
      <span slot="title">{{ title }}</span>
      <span>
        <span class="u-mr1">Select User to Merge</span>
        <el-autocomplete
                    value-key="name"
                    v-model="secondInsuredName"
                    :fetch-suggestions="querySecondInsuredNameSearch"
                    placeholder="Enter User Name"
                    @select="onSelect"
                    icon="edit">
          <template slot-scope="{ item }">
            <div class="item">{{ item.name }}</div>
          </template>
        </el-autocomplete>
      </span>

      <el-table class="u-mt3" :data="usersTableData">
        <el-table-column label="" property="rowTitle" width="170"></el-table-column>
        <el-table-column label="This User" property="firstUser" width="250"></el-table-column>
        <el-table-column label="Selected User" property="secondUser" width="250"></el-table-column>
      </el-table>

      <div v-if="secondUser" class="u-mt2">
        <div class="u-text--danger u-mb2">Notice: {{ firstUser.name }}'s account will hold all the insureds of both users.</div>
        <div class="u-mt3" v-if="secondUser.user_id">
          <el-button icon="el-icon-attract" @click="performMerge" type="danger">Perform Merge</el-button>
        </div>
      </div>
    </div>
    <div v-else class="u-text--center">Loading...</div>
  </el-dialog>
</template>


<script>
import axios from 'axios'
import {axiosWrapper} from '@/shared/api.utils'
import config from '@/config'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'merge-user-dialog',
  props: ['firstUserId', 'visible', 'companyId'],
  data () {
    return {
      secondInsuredName: '',
      secondUser: null,
      loading: false
    }
  },
  watch: {
    visible: function (newVal, oldVal) {
      // we don't have whole users list retrieval on dashboard. We need to check&retrieve whole list
      if (newVal && !oldVal && !this.users) {
        this.loadAllInsureds()
      }
    }
  },
  computed: {
    ...mapState('shared', ['users']),
    firstUser () {
      return this.users[this.firstUserId]
    },
    title () {
      return `Merge With ${this.firstUser.name}`
    },
    usersTableData () {
      let rowPairs = [
        { rowTitle: 'Login', attrName: 'username' },
        { rowTitle: 'Name', attrName: 'name' },
        { rowTitle: 'Enrolled Date', attrName: 'registered_date' },
        { rowTitle: 'Paperless enabled', attrName: 'edelivery' },
        { rowTitle: 'Subaccounts num', attrName: 'subaccounts_quantity' },
        { rowTitle: 'ID', attrName: 'user_id' },
      ]

      let result = []
      rowPairs.forEach(pair => {
        result.push({
          rowTitle: pair.rowTitle,
          firstUser: this.firstUser[pair.attrName],
          secondUser: this.secondUser ? this.secondUser[pair.attrName] : 'N/A'
        })
      })
      return result
    }
  },
  methods: {
    ...mapActions('shared', ['getAllInsureds']),
    onSelect (item) {
      this.secondUser = item
    },
    async loadAllInsureds () {
      try {
        this.loading = true
        await this.getAllInsureds(this.companyId)
      } catch (e) {
        this.$message({
          type: 'error',
          message: `Failed to perform action. ${e.response.message}`
        })
      } finally {
        this.loading = false
      }
    },
    async performMerge () {
      try {
        await this.$confirm(
          `This will remove ${this.secondUser.name}. Continue?`,
          'Merge Users', {
            confirmButtonText: 'Merge',
            cancelButtonText: 'Cancel',
            type: 'info'
          }
        )
      } catch (e) {
        // cancel pressed
        return
      }

      try {
        await axiosWrapper(
          axios.post(`${config.url}/carrier-portal/merge-users/`, {
            merged_user_id: this.firstUserId,
            dissolved_user_id: this.secondUser.user_id
          })
        )
      } catch (e) {
        this.$message({
          type: 'error',
          message: `Failed to perform action. ${e.response.message}`
        })
        return
      }
      await this.loadAllInsureds() // reload all insureds since we've updated users
      this.onCloseDialog()
      this.$emit('reloadContactManagement', this.firstUserId)
    },
    querySecondInsuredNameSearch (queryString, cb) {
      let result = []
      for (let insuredId in this.users) {
        let insured = this.users[insuredId]
        if (insured.user_id === this.firstUser.user_id) {
          continue
        }
        if (this.secondInsuredName !== '' && !insured.name.toLowerCase().includes(this.secondInsuredName.toLowerCase())) {
          continue
        }
        result.push(insured)
      }
      result.sort()
      cb(result)
    },
    onCloseDialog (closeEvent) {
      this.$emit('closeMergeDialogEvent')
    },
  },
}
</script>
